module.exports = __webpack_public_path__ + "img/bmw3-1.cd7f921b.png";